import React, { useState, useRef } from 'react'
import { tokens } from '../../styles/desertFloraTheme'

const EditableList = ({ items, onChange, addLabel }) => {
  const [editingIdx, setEditingIdx] = useState(null)
  const inputRef = useRef(null)

  const handleChange = (idx, value) => {
    const next = [...items]
    next[idx] = value
    onChange(next)
  }

  const handleRemove = (idx) => {
    const next = items.filter((_, i) => i !== idx)
    onChange(next)
    setEditingIdx(null)
  }

  const handleAdd = () => {
    const next = [...items, '']
    onChange(next)
    setEditingIdx(next.length - 1)
    setTimeout(() => inputRef.current?.focus(), 0)
  }

  const handleBlur = (idx) => {
    if (items[idx] === '') handleRemove(idx)
    else setEditingIdx(null)
  }

  const handleKeyDown = (e, idx) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      if (items[idx] === '') handleRemove(idx)
      else setEditingIdx(null)
    }
    if (e.key === 'Escape') {
      if (items[idx] === '') handleRemove(idx)
      else setEditingIdx(null)
    }
  }

  return (
    <div>
      {items.map((item, idx) => {
        const num = String(idx + 1).padStart(2, '0')
        const isEditing = editingIdx === idx

        return (
          <div
            key={idx}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 8,
              padding: '6px 0',
              borderBottom: idx < items.length - 1 ? '1px dashed ' + tokens.line : 'none',
              position: 'relative'
            }}
            onMouseEnter={(e) => {
              const x = e.currentTarget.querySelector('[data-remove]')
              if (x) x.style.opacity = '1'
            }}
            onMouseLeave={(e) => {
              const x = e.currentTarget.querySelector('[data-remove]')
              if (x) x.style.opacity = '0'
            }}
          >
            <span style={{
              fontFamily: tokens.fontMono,
              fontSize: 11,
              color: tokens.ink4,
              fontWeight: 500,
              minWidth: 20,
              paddingTop: 3,
              flexShrink: 0
            }}>
              {num}
            </span>

            {isEditing ? (
              <input
                ref={inputRef}
                type="text"
                value={item}
                onChange={(e) => handleChange(idx, e.target.value)}
                onBlur={() => handleBlur(idx)}
                onKeyDown={(e) => handleKeyDown(e, idx)}
                style={{
                  flex: 1,
                  fontFamily: tokens.fontUi,
                  fontSize: 13,
                  color: tokens.ink,
                  background: 'transparent',
                  border: 'none',
                  borderBottom: '1px solid ' + tokens.primary,
                  outline: 'none',
                  padding: '2px 0'
                }}
              />
            ) : (
              <span
                style={{
                  flex: 1,
                  fontSize: 13,
                  color: tokens.ink,
                  cursor: 'text',
                  padding: '2px 0',
                  minHeight: 20
                }}
                onClick={() => setEditingIdx(idx)}
              >
                {item || <span style={{ color: tokens.ink4 }}>Empty</span>}
              </span>
            )}

            <button
              data-remove
              type="button"
              onClick={() => handleRemove(idx)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: tokens.ink4,
                fontSize: 14,
                padding: '2px 4px',
                opacity: 0,
                transition: 'opacity .12s',
                flexShrink: 0,
                lineHeight: 1
              }}
            >
              &times;
            </button>
          </div>
        )
      })}

      <button
        type="button"
        onClick={handleAdd}
        style={{
          background: 'none',
          border: '1px dashed ' + tokens.line2,
          borderRadius: 8,
          color: tokens.ink3,
          fontSize: 12,
          fontWeight: 600,
          cursor: 'pointer',
          padding: '6px 12px',
          marginTop: 8,
          width: '100%',
          textAlign: 'center',
          transition: 'background .12s'
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = tokens.bg2 }}
        onMouseLeave={(e) => { e.currentTarget.style.background = 'none' }}
      >
        + {addLabel || 'Add item'}
      </button>
    </div>
  )
}

export default EditableList
